import { useState, useEffect } from 'react'
import { TestimonialService, type Testimonial } from '../services/testimonialService'

export function useTestimonials(includeDeleted: boolean = false) {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchTestimonials = async () => {
    setLoading(true)
    setError(null)
    
    try {
      const result = await TestimonialService.getTestimonials(includeDeleted)
      
      if (result.success && result.data) {
        setTestimonials(result.data)
      } else {
        setError(result.error || 'Failed to fetch testimonials')
        setTestimonials([])
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unexpected error occurred')
      setTestimonials([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTestimonials()
  }, [includeDeleted])

  return {
    testimonials,
    loading,
    error,
    refetch: fetchTestimonials
  }
}



